import React, { FC } from 'react';
import Button from 'src/components/Button';
import { HiOutlineCog as SettingIcon } from '@react-icons/all-files/hi/HiOutlineCog';
import { Link } from 'react-router-dom';

const SettingButton: FC = () => {
  return (
    <Link to='/dashboard/settings'>
      <Button size='small' startIcon={<SettingIcon />} variant='outlined' color='primary'>
        Réglages
      </Button>
    </Link>
  );
};

export default SettingButton;
